import React from 'react';
import { Ellipsis1, Ellipsis2, Ellipsis3 } from '../constants/SvgIcons';

const LoadingEllipsis = () => {
  const containerStyle = {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'left',
  };

  const svgStyle = {
    margin: '0 4px',
    fill: 'var(--color-light-blue-primary)',
    animation: 'pulse 1.5s infinite ease-in-out',
  };

  const keyframes = `
    @keyframes pulse {
      0%, 100% {
        transform: scale(1);
        opacity: 0.3;
      }
      50% {
        transform: scale(1.05);
        opacity: 1;
      }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div style={containerStyle}>
        <Ellipsis1 style={{...svgStyle, animationDelay: '0s'}} />
        <Ellipsis2 style={{...svgStyle, animationDelay: '0.5s'}} />
        <Ellipsis3 style={{...svgStyle, animationDelay: '1s'}} />
      </div>
    </>
  );
};

export default LoadingEllipsis;